// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dgrid-header .dojoDndContainer .dgrid-cell {
	display: table-cell; /* override any spurious dojoDndItem settings elsewhere */
}

.dgrid-header .dojoDndItemBefore {
	border-left: 2px dotted #000 !important;
}
.dgrid-header .dojoDndItemAfter {
	border-right: 2px dotted #000 !important;
}

#dgrid-css-extensions-ColumnReorder-loaded { /* load indicator for xstyle */
	display: none;
}
`, "",{"version":3,"sources":["webpack://./target/debug/2P/derived/ui/dgrid/css/extensions/ColumnReorder.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB,EAAE,yDAAyD;AAC/E;;AAEA;CACC,uCAAuC;AACxC;AACA;CACC,wCAAwC;AACzC;;AAEA,6CAA6C,8BAA8B;CAC1E,aAAa;AACd","sourcesContent":[".dgrid-header .dojoDndContainer .dgrid-cell {\n\tdisplay: table-cell; /* override any spurious dojoDndItem settings elsewhere */\n}\n\n.dgrid-header .dojoDndItemBefore {\n\tborder-left: 2px dotted #000 !important;\n}\n.dgrid-header .dojoDndItemAfter {\n\tborder-right: 2px dotted #000 !important;\n}\n\n#dgrid-css-extensions-ColumnReorder-loaded { /* load indicator for xstyle */\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
